export function Divider() {
  return <hr />;
}
